import * as React from "react";
import { connect } from "react-redux";
import { actions as nameActions } from "src/actions/name.actions";
import { actions } from "src/actions/main.actions";
import { actions as homeActions } from "src/actions/home.actions";
import Container from "src/core/ui/container";
import Grid, { Col } from "src/core/ui/grid";
import Card from "src/core/ui/card";
import { ImageUpload } from "src/core/ui/upload";
import ArtHeader from "./parts/art-header";
import FormInput from "src/core/ui/input";
import { RouteComponentProps, withRouter } from "react-router-dom";
import ArtsDataService from "./arts.data.service";
import { resolve } from "inversify-react";
import RaritySelect from "../../core/ui/data-component/rarity-select";
import Form from "../../core/ui/form";
import ArtDescription from "./parts/art-description";
import ArtInspiration from "./parts/art-inspiration";
import ArtProcess from "./parts/art-process";
import ArtFinal from "./parts/art-final";
import ToastService from "../../services/toast.service";
import Button from "../../core/ui/button";
import IdentityService from "../../services/identity.service";
import BlockchainService from "src/services/blockchain.service";
import NavNotifier from "src/core/ui/nav-notifier";
import { IApplicationState, Identity, IDetailedArt } from "../../typings";

interface IArtEditProps {
    id: string;
    identity: Identity;
    wallet: string;
}

type ArtEditProps = IArtEditProps & typeof actions & typeof homeActions & RouteComponentProps<{id: string}>;
interface IArtEditState extends Partial<IDetailedArt> {
    cloneOpened: boolean;

    editionErrors?: string[];
}

export class ArtEdit extends React.Component<ArtEditProps, IArtEditState> {

    @resolve
    public artDataService: ArtsDataService;

    @resolve
    public identityService: IdentityService;

    @resolve
    public blockchainService: BlockchainService;

    @resolve
    public toastService: ToastService;

    constructor(props: any) {
    super(props);
    this.state =  {
            cloneOpened: false,
        };
    }

    public completeModel = () => {
        if (!this.state.description_module) {
            this.setState({description_module: { description: "", visible: true}});
        }
        if (!this.state.inspiration_module) {
            this.setState({inspiration_module: { description: "", visible: false}});
        }
        if (!this.state.final_piece_module) {
            this.setState({final_piece_module: { description: "", visible: false}});
        }
        if (!this.state.process_module) {
            this.setState({process_module: { description: "", visible: false}});
        }
    }

    public componentDidMount() {
        this.artDataService.getToken(this.props.match.params.id, 1).then((result) => {
            this.setState({...result}, this.completeModel);

        })
        .catch((error) => {

        });
    }

    public editToken = () => {
        console.log("edit state", this.state);
        console.log(this.state);
        this.artDataService.editToken(this.props.match.params.id, this.state).then((rsult) => {
            this.toastService.showToast("Data Saved!", "", "success");
            this.props.history.push("/account/collection");
        });
    }

    public cloneToken = () => {

        // this.blockchainService.getLastArtworkId().then(result => {

        //     const id = result + 1;

        //     if(this.state){
        //         this.blockchainService.createArtwork(
        //             this.state.title || 'Clone',
        //             this.state.medium || '',
        //             this.state.dimensions || '',
        //             this.state.rarity || 1,
        //             {
        //                 edition_number: this.state.edition_number || 1,
        //                 edition_count: this.state.edition_count || 1,
        //                 copy_of: this.state.blockchain_hash || '',
        //                 edition_type:  JSON.parse(this.state.editionType as any)
        //             },
        //             this.state.location || '',
        //         ).then(r => {
        //             const model = this.state as any;
        //             this.artDataService.cloneToken(model.edition_number,
        //                  model.id, model.blockchain_hash, id, this.state.editionType as any)
        //                  .then(r => {
        //                      this.props.history.push("/arts")
        //                  })
        //                  .catch(err => {
        //                      this.setState({editionErrors: err.edition_number})
        //                  })
        //         })
        //     }
        // })
        // if(this.blockchainService.createArtwork().then()){

        // }
    }

    public canBeCloned = () => {
        return !this.state.isCopy;
    }

    public canEdit = async () => {

        const result = this.identityService.isAuthenticated() && (
        this.identityService.isAdmin || (this.props.identity.userInfo ?
            this.props.identity.userInfo.wallet_address == this.state.owner_wallet : false));

        return result;
    }

    public renderInner = () => {
        const size = 90;
        return (
            <NavNotifier idk="light">
            <Container light={true} >

                <Form onSubmit={this.editToken}>
                    <Grid centered={true}>
                        <Col size={size}>
                            <div className="absolute-left button-group">
                                <Button presentation="light" extraProps={{type: "submit"}} as={<button/>} >Publish </Button>
                                <Button presentation="blueprint" onClick={() => this.props.history.goBack()}>Cancel</Button>
                            </div>

                        </Col>
                    </Grid>
                    <Grid centered={true}>

                        <Col size={size}>
                            <Card>

                                <h2 className="card-h2">Complete certificate</h2>
                                <Grid centered={true} fillRow={true}>
                                    <Col size={50}>
                                        <ImageUpload
                                            onDelete={() => {
                                                    this.setState({image: null as any});
                                                }
                                            }
                                            value={this.state.image}
                                            onUpload={(e) =>
                                                this.setState({image: e.id})
                                            }
                                        />
                                    </Col>
                                    <Col size={2}>
                                    </Col>
                                    <Col size={48}>
                                        <ArtHeader id={this.props.id} artist_wallet={this.props.wallet} edit={true}/>
                                        <h2  className="art-title">{this.state.title}</h2>
                                        <FormInput
                                            label="Creation year"
                                            disabled={true}
                                            value={this.state.creation_year || "2019"}
                                            style="dark"
                                        />
                                        {/*<DatePicker
                                            label='Certification date'
                                            disabled
                                            value={this.state.certification_date || '2019-01-01'}
                                            format='YYYY-MM-DD'
                                        />*/}
                                        <FormInput
                                            style="dark"
                                            label="Medium"
                                            disabled={true}
                                            value={this.state.medium}
                                            onChange={(e) => this.setState({medium: e})}
                                        />
                                        <FormInput
                                            style="dark"
                                            label="Dimensions"
                                            disabled={true}
                                            value={this.state.dimensions}
                                            onChange={(e) => this.setState({dimensions: e})}
                                        />

                                        <RaritySelect
                                            label="Category"

                                            value={this.state.rarity}
                                            onChange={(e) => this.setState({rarity: e.id})}
                                            disabled={true}
                                        />
                                        {/* <FormInput
                                            style='dark'
                                            label='Edition number'
                                            disabled
                                            value={this.state.edition_count && this.state.edition_count > 1 ? `${this.state.edition_number} of ${this.state.edition_count} / ${this.artDataService.discriminateEditionType(this.state.editionType as any)} (${this.artDataService.getApMaximum(this.state.edition_count)} AP)`: 'Unique edition'}
                                            onChange={e => {}}
                                        /> */}
                                        <FormInput
                                            style="dark"
                                            label="Mold created in"
                                            disabled={true}
                                            value={this.state.mold_creation_place}
                                            onChange={(e) => this.setState({mold_creation_place: e})}
                                        />
                                    </Col>
                                </Grid>

                            </Card>
                            <ArtDescription
                                onChange={(e) => this.setState({description_module: {...e}})}
                                model={this.state.description_module || {
                                    description: "",
                                    visible: true,
                                }}/>
                            <ArtInspiration
                                onChange={(e) => this.setState({inspiration_module: {...e}})}

                                model={this.state.inspiration_module || {
                                    description: "",
                                    quote: "",
                                    visible: false,
                                }}
                            />
                            <ArtProcess
                                onChange={(e) => this.setState({process_module: {...e}})}
                                model={
                                    this.state.process_module || {
                                        description: "",
                                        visible: false,
                                    }
                                }
                            />

                            <ArtFinal
                                onChange={(e) => this.setState({final_piece_module: {...e}})}
                                model={
                                    this.state.final_piece_module || {
                                        description: "",
                                        visible: false,
                                    }
                                }
                            />

                        </Col>

                    </Grid>
                    <Grid centered={true}>
                        <Col size={size}>

                            <div className="button-group absolute-left">
                                    <Button presentation="light" extraProps={{type: "submit"}} as={<button/>} >Publish </Button>
                                    <Button onClick={() => this.props.history.goBack()} presentation="blueprint">Cancel</Button>
                            </div>
                        </Col>
                    </Grid>
                </Form>
            </Container>
            </NavNotifier>);
    }

    public render() {
        return (
            this.renderInner()
          );
    }

}

function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return {
        ...ownProps,
        ...state.routing,
        identity: state.identity,
        wallet: state.identity.userInfo ? state.identity.userInfo.wallet_address : "Me",
        };
}
export default withRouter(connect(mapStateToProps, {...actions, ...nameActions, ...homeActions})(ArtEdit));



// WEBPACK FOOTER //
// ./src/components/arts/art-edit.tsx